import { styled } from '@mui/material'
import { ReplySmallIcon } from '$common/icons/reply'
import { useMessageByIid } from '$logic/message/react-hook'
import { scrollToMessageByIid } from '$logic/opened-room'
import { RemovePersonIcon } from '$common/icons/removed-message'
import {
  MessagePreviewRoot,
  MessagePreviewVerticalSideBox,
  MessagePreviewThumbnail,
  MessagePreviewInfoContainer,
  MessagePreviewInfoRow,
  MessagePreviewMessageTypeIconMap,
  MessagePreviewDescriptorContainer,
} from '$common/messsage-preview'
import {
  SenderName,
  MessageDescriptor,
  MessagePreviewSkeleton,
} from './components'
import { MessagePreviewWappIcon } from '$common/messsage-preview/message-preview-wapp-icon'

const StyledReplyIcon = styled(ReplySmallIcon)`
  width: 20px;
  height: 18px;
  /* @noflip */
  margin: -2px 0 0 4px;
`

interface Props {
  messageIid: number
  roomId: string
  showReplyIcon?: boolean
  fromMe?: boolean
}

export function Reply({ messageIid, roomId, showReplyIcon, fromMe }: Props) {
  const { message, loading } = useMessageByIid(messageIid, roomId)

  if (!message)
    return (
      <MessagePreviewRoot>
        <MessagePreviewVerticalSideBox />
        <MessagePreviewSkeleton />
      </MessagePreviewRoot>
    )

  const isDeleted = message?.patches?.deleted
  const MessageTypeIcon =
    message?.type !== 'WAPP' &&
    !isDeleted &&
    message &&
    MessagePreviewMessageTypeIconMap[message.type]

  const hasTypeIcon = !!MessageTypeIcon || message?.type === 'WAPP'

  return (
    <MessagePreviewRoot
      fromMe={fromMe}
      onClick={e => {
        e.stopPropagation()
        if (!(isDeleted || loading)) scrollToMessageByIid(messageIid)
      }}
      style={isDeleted || loading ? {} : { cursor: 'pointer' }}
    >
      <MessagePreviewVerticalSideBox fromMe={fromMe} />

      {loading ? (
        <MessagePreviewSkeleton />
      ) : (
        <>
          {!isDeleted && <MessagePreviewThumbnail message={message} />}

          <MessagePreviewInfoContainer>
            <MessagePreviewInfoRow>
              {isDeleted ? (
                <RemovePersonIcon />
              ) : (
                showReplyIcon && <StyledReplyIcon />
              )}

              <SenderName message={message} fromMe={fromMe as boolean} />
            </MessagePreviewInfoRow>

            <MessagePreviewInfoRow>
              {MessageTypeIcon && (
                <MessageTypeIcon
                  sx={{
                    width: '20px',
                    height: '16px',
                    color: fromMe ? 'neutral000' : 'neutral500',
                  }}
                />
              )}
              {message?.type === 'WAPP' && (
                <MessagePreviewWappIcon
                  wappId={message.attachment?.wappId}
                  size={16}
                  radius={6}
                />
              )}
              <MessagePreviewDescriptorContainer hasMarginToIcon={hasTypeIcon}>
                <MessageDescriptor message={message} fromMe={fromMe} />
              </MessagePreviewDescriptorContainer>
            </MessagePreviewInfoRow>
          </MessagePreviewInfoContainer>
        </>
      )}
    </MessagePreviewRoot>
  )
}

Reply.defaultProps = {
  showReplyIcon: false,
  fromMe: true,
}
